
const login = (user) => {
    return {
        type: 'LOGIN',
        user
    }
}

const logout = () => {
    return {
        type: 'LOGOUT'
    }
}

const updateAuthLogo = (logo) => {
    return {
        type: 'LOGO',
        logo
    }
}


const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return action.user;
        case 'LOGO':
            const cp = state;
            cp.user.logo = action.logo;
            return cp;
        case 'LOGOUT':
            return '';
        default:
            return state;
    }
}

export { login, updateAuthLogo, logout, authReducer as default }